import { OrderReprocessDto } from './../../model/order-reprocess-dto';
import { AppValidationService } from './../../services/app-validation.service';
import { DatasharingService } from './../../services/datasharing.service';
import { ResultDto } from './../../model/result-dto';
import { FileExportService } from 'src/app/services/file-export.service';

import { OrderDetailsdto } from '../../model/orderDetailsdto';
import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpclientService } from 'src/app/services/httpclient.service';
import { PurchaseOrderComponent } from '../purchase-order/purchase-order.component';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { OrderInterfaceLogFileDto } from 'src/app/model/order-interface-log-file-dto';
import { DomSanitizer } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { UpdateOrderDto } from 'src/app/model/update-order-dto';
import { OrderItemDto } from 'src/app/model/OrderItemDto';
import { OrderItemMasterDto } from 'src/app/model/order-item-master-dto';
declare var $: any;
@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.css']
})
export class OrderDetailsComponent implements OnInit {
  oneAtATime;
  orderItemHistory: OrderDetailsdto;
  orderDetailsdto: OrderDetailsdto;
  initialOrderDetailsdto: OrderDetailsdto;
  id: number;
  orderStatus: string;
  purchaseOrderNumber: string;
  private sub: any;
  loading: boolean;
  isPartner = false;
  isMultipleBol = false;
  orderInterfaceLogFileDto: OrderInterfaceLogFileDto;
  fileUrl;
  resultDto: ResultDto;
  axaltaCodeDisable = true;
  axaltaUomDisable = true;
  editButtonDisable = true;
  saveButtonDisable = false;
  saveBtnDisable = true;
  modalPopup = false;
  updatedModalPopup = false;
  updateOrderDto: UpdateOrderDto;
  orderItemDto: OrderItemDto[]; 
  orderItemHistoryDto: OrderItemDto[];  
  intiallOrderItemDto: OrderItemDto[];
  isNullValue = false;
  isValueNoChange: boolean;
  axaltaCodeArrray: Array<string> = [];
  axaltaUomArrray: Array<string> = [];
  accDrpDwnIcn = true;
  accDrpDwnIcnOpen = false;
  orderItemMasterDtoList: OrderItemMasterDto[];
  isValueExit;
  isValueExitModel;
  isXmlDataNotAvailable = false;
  showArrow: any[] = [];
  customerOrderId;
  sapPayerNo;
  distSapPayerNo;
  globelUomValidation;
  poType;
  isCreateBolBtnVisible: boolean;
  userRoleId;
  isDistributor:boolean;
  isAdmin:boolean;
  axaltaCartKey:string;
  constructor(private route: ActivatedRoute, private router: Router, private sharingData: DatasharingService,
              private httpclientService: HttpclientService, public appSettingService: AppSettingService,
              public fileExportService: FileExportService, private sanitizer: DomSanitizer, private location: Location,
              public appValidationService: AppValidationService) {
    if (sessionStorage.getItem('isPartner') === '1') {
      this.isPartner = true;
      console.log('true..' + this.isPartner);
    } else {
      this.isPartner = false;
    }
    
    this.userRoleId = sessionStorage.getItem('roleId');
    this.getItemMasterDataList();    
    this.setSessionVariableForCreateBolMenue();
    console.log("isCreateBolBtnVisible : " + this.isCreateBolBtnVisible);
    this.isDistributor = sessionStorage.getItem('roleId')!='6' ? false : true; 
    this.isAdmin = sessionStorage.getItem('roleId')=='1' ? true : false;   
  }

  setSessionVariableForCreateBolMenue()
  {
    for(let i=0; i<this.appSettingService.menubarGlobelList.length; i++)
          {              
              for(let  j = 0; j < this.appSettingService.menubarGlobelList[i].moduleName.length; j++)
              {
                 if(this.appSettingService.menubarGlobelList[i].moduleName[j] == 'Create Bol')
                 {                  
                  this.isCreateBolBtnVisible = true;
                  break;                                   
                 }                
                 else
                 {
                  this.isCreateBolBtnVisible = false;
                 }              
              }
                         
              if(this.isCreateBolBtnVisible)
              {           
                break;
              }
          }
  }

  changeEditButton() {
    this.editButtonDisable = false;
    this.saveButtonDisable = true;
    this.axaltaCodeDisable = false;
    this.axaltaUomDisable = false;    
  }

  isValueExitOK() {
    this.isValueExitModel = false;
  }

    pressingOK() {
    this.modalPopup = false;
    this.loading = true;
    this.orderDetailsdto.orderItemDtoList = [];
    this.updateOrderDto = {
      orderItems : this.orderItemDto,
      poId : this.id,
      saveOrCancel: 0,
      customerOrderId: this.customerOrderId,
      //sapPayerNo: this.sapPayerNo      
      sapPayerNo: this.distSapPayerNo
      };
    this.httpclientService.updateOrderItems(this.updateOrderDto).subscribe(data => {
      this.globelUomValidation = true;

      this.axaltaCodeArrray = [];
      this.axaltaUomArrray = [];


      this.orderDetailsdto =  this.initialOrderDetailsdto;
      this.orderDetailsdto.orderItemDtoList = data.orderItemDtoList;
      this.orderDetailsdto.orderItemDtoList.forEach(pdto => {

        this.axaltaCodeArrray.push(pdto.axaltaCode);
        this.axaltaUomArrray.push(pdto.axaltaUom);

        if (pdto.axaltaCodeIfExitFlag === 0 && pdto.axaltaUomIfExitFlag === 0) {
          this.globelUomValidation = false;
        }

        if (pdto.supplierShippedQty === 0) {
          this.isMultipleBol = false;
        }
       });
      // if (!this.globelUomValidation )
      //   {
      //     this.isValueExitModel = true;
      //     this.loading = false;
      //   } else {

      //     this.axaltaCodeDisable = true;
      //     this.axaltaUomDisable = true;
      //     this.editButtonDisable = true;
      //     this.saveButtonDisable = false;
      //     this.updatedModalPopup = true;
      //   }
     // this.router.navigate(['/order-details/' + this.id + '/' + this.purchaseOrderNumber + '/' + this.orderStatus]);
      this.axaltaCodeDisable = true;
      this.axaltaUomDisable = true;
      this.editButtonDisable = true;
      this.saveButtonDisable = false;
      this.loading = false;
    }
    );

   // this.router.navigate(['user admin']);
   this.saveBtnDisable = true;//Disable save button
  }

  updatedMessageEvent() {
    this.updatedModalPopup = false;
    this.editButtonDisable = true;
    this.saveButtonDisable = false;
    this.axaltaCodeDisable = true;
    this.axaltaUomDisable = true;
  }

  pressingCancel() {
    this.modalPopup = false;
  }

  isNullValueEvent(){
    this.isNullValue = false;
    this.isValueNoChange = false;
    this.isXmlDataNotAvailable = false;
  }

  updateOrderItem() {
    this.loading = true;
    this.isValueNoChange = true ;
    this.orderItemDto = this.orderDetailsdto.orderItemDtoList;
    for (let i = 0; i < this.orderDetailsdto.orderItemDtoList.length ; i++) {

        if (this.orderDetailsdto.orderItemDtoList[i].axaltaCode === '' || this.orderDetailsdto.orderItemDtoList[i].axaltaUom === '') {
          this.isNullValue = true;
         } else if (this.orderDetailsdto.orderItemDtoList[i].axaltaCode !== this.axaltaCodeArrray[i]
          || this.orderDetailsdto.orderItemDtoList[i].axaltaUom !== this.axaltaUomArrray[i]) {
          this.isValueNoChange = false ;
         }

       }

    if (this.isNullValue ||  this.isValueNoChange) {
      this.loading = false;
      } else {
    this.isValueExit = true;
    // this.orderDetailsdto.orderItemDtoList.forEach(pdto => {
    //   console.log('..axaltaCode..'+ pdto.axaltaCode );
    //   if (!this.orderItemMasterDtoList.some(r => r.partNumber === pdto.axaltaCode)) {
    //     pdto.axaltaCodeIfExitFlag = 0;
    //     this.isValueExit = false;

    //   } else {
    //     pdto.axaltaCodeIfExitFlag = 1;
    //   }
    //   console.log('..uom..'+ pdto.axaltaUom );

    //   if (!this.orderItemMasterDtoList.some(r => r.uom === pdto.axaltaUom)) {
    //     pdto.axaltaUomIfExitFlag = 0;
    //     this.isValueExit = false;
    //   } else {
    //     pdto.axaltaUomIfExitFlag = 1;
    //   }
    //    });

       console.log('..this.isValueExit..'+this.isValueExit);
    // if (this.isValueExit) {



    this.updateOrderDto = {
    orderItems : this.orderItemDto,
    poId : this.id,
    saveOrCancel: 1,
    customerOrderId: this.customerOrderId,
    sapPayerNo: this.distSapPayerNo
    };
    this.updateOrderDto.orderItems.forEach(pdto => {
     console.log('pdto..'+ pdto);
    });
    this.isMultipleBol = true;
    this.httpclientService.updateOrderItems(this.updateOrderDto).subscribe(data => {
      this.globelUomValidation = false;

      this.axaltaCodeArrray = [];
      this.axaltaUomArrray = [];
      this.orderItemDto =  data.orderItemDtoList;
      this.orderDetailsdto.orderItemDtoList = data.orderItemDtoList;
      data.orderItemDtoList.forEach(pdto => {

        this.axaltaCodeArrray.push(pdto.axaltaCode);
        this.axaltaUomArrray.push(pdto.axaltaUom);
        console.log("pdto.axaltaCodeIfExitFlag."+ pdto.axaltaCodeIfExitFlag);
        console.log(" pdto.axaltaUomFlag."+ pdto.axaltaUomIfExitFlag);

        if(pdto.axaltaCodeIfExitFlag === 1 || pdto.axaltaUomIfExitFlag === 1) {
          this.globelUomValidation = true;
        }

        if(pdto.supplierShippedQty === 0){
          this.isMultipleBol = false;
        }
       });

      console.log('final result...' + this.globelUomValidation);


      if (this.globelUomValidation ) {
        this.isValueExitModel = true;
        this.loading = false;
        } else if (!this.globelUomValidation ) {

          this.loading = false;
          this.axaltaCodeDisable = true;
          this.axaltaUomDisable = true;
          this.updatedModalPopup = true;
        }
    }
    );
  // } else {
  //   // this.isValueExitModel = true;
  //   // this.loading = false;
  // }
}
}

  cancelOrderDetails() {
    this.modalPopup = true;
    // this.editButtonDisable = true;
    // this.saveButtonDisable = false;    
  }

  navigateRoute() {
    this.router.navigate(['dashboard']);
    this.sharingData.isVisibleSource.next('orderDetails');

  }

  onchangeEdit(dataField,index: number , dataValue) {
    //console.log('index..'+index+'..'+ dataValue.target.value);
    this.isValueNoChange = false;
    if (dataField === 'axaltaCode') {
    this.orderDetailsdto.orderItemDtoList[index].axaltaCode = dataValue.target.value;
    this.orderDetailsdto.orderItemDtoList[index].editableFlag = 1;
    } else if (dataField === 'axaltaUom') {
      this.orderDetailsdto.orderItemDtoList[index].axaltaUom = dataValue.target.value;
      this.orderDetailsdto.orderItemDtoList[index].editableFlag = 1;
    }

  }

  arrowClick(){
    this.accDrpDwnIcn = !this.accDrpDwnIcn;
    this.accDrpDwnIcnOpen = !this.accDrpDwnIcnOpen;
  }

  ngOnInit() {
    $(document).ready(
      // console.log("PoCOMp")
      () => {

        $('.optDroDwn li a').on("click", function () {
          let dropDwnVal = $(this).html();
          console.log(dropDwnVal, "thththt")
          $(this).parents(".btn").find("span").html(dropDwnVal)
          // alert("ji")
        })
        $(".liBlks .dropDownIcon").on("click", function () {
          let currentLis = $(this).parents(".liBlks");
          currentLis.find(".dropDownContent").slideToggle()
          // $(".liBlks .dropDownContent").slideUp()
          $(this).toggleClass("dropDownIcon").toggleClass("dropUpIcon");

        })
        let searchInp = $(".searchContr .searchInput");
        let searchCloseIcon = $(".searchCloseIcon")
        $(searchInp).on("focus", function () {
          $(".searchIcon").addClass("searchIconActive")
          $(".searchCloseIcon").fadeIn("slow")
        })
        $(searchInp).on("blur", function () {
          $(".searchIcon").removeClass("searchIconActive")
          $(".searchCloseIcon").fadeOut("slow")
        })
        $(searchCloseIcon).hover(function () {
          $(searchCloseIcon).toggleClass("searchCloseIconFocus")
        })

        $(".accDrpDwn1").on("click", function () {
          $(this).toggleClass("accDrpDwnIcnOpen").toggleClass("accDrpDwnIcn");
          let parentTr = $(this).parent("td").parent("tr");
          let closestAcc = parentTr.siblings(".accordionTR0");
          console.log(closestAcc)
          $(closestAcc).slideToggle(300);
          $(this).parents("tr").toggleClass("noBorder")

        });
        $(".proTabCont .acrdnContr").on("click",()=>{
          let partentUl = $(this).parent(".proTabCont")
          partentUl.addClass(".accPnlBg")
        })

      }
    )
    this.sub = this.route.params.subscribe(params => {
      this.id = +params['id'];
      this.purchaseOrderNumber = '' + params['ponumber'];
      this.orderStatus = '' + params['postatus'];
      this.poType = '' + params['potype'];
      this.axaltaCartKey = '' + params['axaltaCartKey']
      console.log('id..' + this.id);
      this.getPurchaseOrder(this.id,this.axaltaCartKey,this.purchaseOrderNumber);

    });
  }
  goBack() {
    // window.history.back();
    this.location.back();

    console.log('goBack()...');
  }

  getPurchaseOrder(poNo,axaltaCartKey,purchaseOrderNumber) {
    this.axaltaCodeArrray = [];
    this.axaltaUomArrray = [];
    this.loading = true;
    this.isMultipleBol = true;
    this.httpclientService.getOrderDetails(poNo,axaltaCartKey,purchaseOrderNumber).subscribe(data => {


      this.loading = false;
      this.initialOrderDetailsdto = data;
      this.orderDetailsdto = data;
      this.orderItemDto= data.orderItemDtoList;
      this.orderItemHistoryDto=data.orderDetailHistoryDetailList;
      this.customerOrderId = this.orderDetailsdto.customerOrderId;
      this.sapPayerNo = this.orderDetailsdto.customerShipToIdMsoPayer;
      this.distSapPayerNo = this.orderDetailsdto.sapPayerNumber;
      this.orderDetailsdto.orderItemDtoList.forEach(pdto => {

        this.axaltaCodeArrray.push(pdto.axaltaCode);
        this.axaltaUomArrray.push(pdto.axaltaUom);
        console.log(" this.axaltaCodeArrray.."+ this.axaltaCodeArrray);
        console.log(" this.axaltaUomArrray.."+ this.axaltaUomArrray);

        if(pdto.supplierShippedQty === 0){
          this.isMultipleBol = false;
          pdto.axaltaCodeFlag = false;
          pdto.axaltaUomFlag = false;
        } else {
          pdto.axaltaCodeFlag = true;
          pdto.axaltaUomFlag = true;
        }
       });

      let len = this.orderDetailsdto.orderInterfaceLogDtoList.length;
      for (let i = 0; i < len; i++) {
        if (this.orderDetailsdto.orderInterfaceLogDtoList[i].typeOfTransaction == "Bill Of lading") {
          this.orderDetailsdto.orderInterfaceLogDtoList[i].typeOfTransaction = "Bill of Lading";
        }
        if (this.orderDetailsdto.orderInterfaceLogDtoList[i].typeOfTransaction == "Updated BOL") {
          this.orderDetailsdto.orderInterfaceLogDtoList[i].typeOfTransaction = "Updated BoL";
        }
      }

    }
    );
  }



  getOrderFileDownload(docId, fileId, fileName, uniqueIdentificationText, fileArchivalId) {
    console.log("docId :"+docId);
    console.log("fileId :"+fileId);
    console.log("fileName :"+fileName);
    var newfileName = fileName.substring(fileName.lastIndexOf("\\")+1, fileName.indexOf("."));
    console.log("newfileName :"+newfileName);
    console.log("uniqueIdentificationText :"+uniqueIdentificationText);
    console.log("fileArchivalId :"+fileArchivalId);
    if(uniqueIdentificationText == ''){
      console.log("getOrderFileDownload using getOrderFileDownloadDebitCredit");
      this.loading = true;
      this.httpclientService.getOrderFileDownloadDebitCredit(docId, fileId, fileArchivalId).subscribe(data => {
        console.log("data.."+data);
        if (data != null) {
        this.orderInterfaceLogFileDto = data;
        const blob = new Blob([this.orderInterfaceLogFileDto.fileContent], { type: 'application/xml' });
        // window.location.href = '' + this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
        const url = window.URL.createObjectURL(blob);
        var anchor = document.createElement("a");
        anchor.download = newfileName;
        anchor.href = url;
        anchor.click();
  
        // window.open(url);
        this.loading = false;
        // window.location.href = this.orderInterfaceLogFileDto.fileContent;
        console.log('this.orderInterfaceLogFileDto.fileContent..' + this.orderInterfaceLogFileDto.fileName);
       } else {
        this.loading = false;
        this.isXmlDataNotAvailable = true;
        }
      },
        error => {
          this.loading = false;
          alert('File is not found');
        },
      );
    }else {
      console.log("In other file download using uniqueIdentificationText :"+uniqueIdentificationText);
      console.log("getOrderFileDownload using getOrderFileDownload");
      this.loading = true;
      this.httpclientService.getOrderFileDownload(docId, fileId, uniqueIdentificationText).subscribe(data => {
      console.log("data.."+data);
      if (data != null) {
      this.orderInterfaceLogFileDto = data;
      const blob = new Blob([this.orderInterfaceLogFileDto.fileContent], { type: 'application/xml' });
      // window.location.href = '' + this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));
      const url = window.URL.createObjectURL(blob);
      var anchor = document.createElement("a");
      anchor.download = fileName;
      anchor.href = url;
      anchor.click();

      // window.open(url);
      this.loading = false;
      // window.location.href = this.orderInterfaceLogFileDto.fileContent;
      console.log('this.orderInterfaceLogFileDto.fileContent..' + this.orderInterfaceLogFileDto.fileName);
     } else {
      this.loading = false;
      this.isXmlDataNotAvailable = true;
      }
    },
      error => {
        this.loading = false;
        alert('File is not found');
      },
    );
    }
  }



  getOrderReprocess(poId, docId, fileId, fileName, uniqueIdentificationText,poNumber,bolReprocess, supplierDocReferenceNumber, fileArchivalId) {
    console.log('fileName..' + fileName);
    const newFileName = fileName.substring(0, fileName.length - 4);
    console.log('newFileName..' + newFileName);
    this.loading = true;
    let orderReprocessDto= new OrderReprocessDto(poId, docId , fileId, newFileName,
      uniqueIdentificationText, this.poType,poNumber,bolReprocess,supplierDocReferenceNumber, fileArchivalId);
    this.httpclientService.savleOrderReprocess(orderReprocessDto).subscribe(data => {
      this.resultDto = data;
      console.log('data..' + this.resultDto.resultMessage);
      this.loading = false;
      alert(''+this.resultDto.resultMessage);
    }
    );
  }


  getItemMasterDataList() {

    this.loading = true;
    if (this.appSettingService.orderItemMasterDtoList === null || this.appSettingService.orderItemMasterDtoList === undefined ) {
      this.httpclientService.getOrderItemMasterList().subscribe(
        data => {
          this.orderItemMasterDtoList = data;
          this.appSettingService.orderItemMasterDtoList = data;

         // this.loading = false;
        }
      );

    //  console.log('Partner is null from backend' + this.appSettingService.partnerMSOGlobelList);
      } else {
        this.orderItemMasterDtoList = this.appSettingService.orderItemMasterDtoList;
       // this.loading = false;
      //  console.log('Partner is not null from frontend' + this.appSettingService.partnerMSOGlobelList);
      }
  }

  onUOMEdited(searchValue: string): void {  
    //console.log("onUOMEdited : " + searchValue);
    this.saveBtnDisable = false;
  }
  
  onDisPartdited(searchValue: string): void {  
    //console.log("onDisPartdited : " + searchValue);
    this.saveBtnDisable = false;
  }
  
  getBolDetails(dataField: any,event: any)
  {    
    if(event)
    {
    this.loading = true;
    this.httpclientService.getBolDetailList(this.axaltaCartKey,this.purchaseOrderNumber,dataField).subscribe(
      data => {    
        this.loading = false;
        this.orderItemHistory = data;        
      }
    );
    //this.loading = true;
   }
  }
}
